import React from 'react';
import PropTypes from 'prop-types';
import reactifyWC from 'reactify-wc';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import isLinkActive from 'helpers/isLinkActive';
import { useCanAddFunds } from 'helpers/useCanAddFunds';
import styles from './styles.module.scss';
import { useIsCorporateAccount } from '@nbx/frontend-helpers/subscribe';

const NBXButtonText = reactifyWC('nbx-button-text');
const microapps = window.MICROFRONTENDS_CONFIG;

function MobileNavigation(props) {
  const location = useLocation();
  const { t } = useTranslation();
  const canAddFunds = useCanAddFunds();
  const isCorporateAccount = useIsCorporateAccount();

  const renderLoggedOutContent = () => {
    return (
      <div className={styles.navigation}>
        <NBXButtonText
          to={microapps?.routes?.markets?.path}
          onClick={props.toggleNav}
          navigation-active={isLinkActive(location, [
            ...window.GET_LOCALE_PATHS(microapps?.routes?.markets?.path),
            ...window.GET_LOCALE_PATHS(microapps?.routes?.trading?.path)
          ])}
          navigation>
          {t('header_link_markets')}
        </NBXButtonText>

        <nbx-button-text
          navigation
          onClick={() => {
            props.toggleNav();
            props.openOTCModal();
          }}>
          {t('header_link_otc')}
        </nbx-button-text>

        <nbx-button-text onClick={props.toggleNav} navigation href="https://nbxsupport.zendesk.com">
          {t('common_support')}
        </nbx-button-text>
      </div>
    );
  };

  const renderLoggedInContent = () => {
    return (
      <>
        <div className={styles.actions}>
          <nbx-button
            onClick={() => canAddFunds && props.openAddFunds()}
            icon="add_funds"
            disabled={!canAddFunds}>
            {t('header_addfunds_btn')}
          </nbx-button>
          <nbx-button onClick={props.openQuickBuy} icon="instant_trade">
            {t('header_instanttrade_btn')}
          </nbx-button>
        </div>

        <div className={styles.navigation}>
          <nbx-button-text
            to={microapps?.routes?.dashboards?.path}
            navigation-active={isLinkActive(
              location,
              window.GET_LOCALE_PATHS(microapps?.routes?.dashboards?.path)
            )}
            navigation
            onClick={props.toggleNav}>
            {t('header_link_dashboard')}
          </nbx-button-text>

          <nbx-button-text
            to={microapps?.routes?.markets?.path}
            navigation-active={isLinkActive(location, [
              ...window.GET_LOCALE_PATHS(microapps?.routes?.markets?.path),
              ...window.GET_LOCALE_PATHS(microapps?.routes?.trading?.path)
            ])}
            navigation
            onClick={props.toggleNav}>
            {t('header_link_markets')}
          </nbx-button-text>

          <nbx-button-text
            to={microapps?.routes?.orders?.path}
            navigation-active={isLinkActive(
              location,
              window.GET_LOCALE_PATHS(microapps?.routes?.orders?.path)
            )}
            navigation
            onClick={props.toggleNav}>
            {t('header_link_orders')}
          </nbx-button-text>

          <nbx-button-text
            to={microapps?.routes?.funds?.path}
            navigation-active={isLinkActive(
              location,
              window.GET_LOCALE_PATHS(microapps?.routes?.funds?.path)
            )}
            navigation
            onClick={props.toggleNav}>
            {t('header_link_funds')}
          </nbx-button-text>

          <nbx-button-text
            to={microapps?.routes?.staking?.path}
            onClick={props.toggleNav}
            navigation-active={isLinkActive(
              location,
              window.GET_LOCALE_PATHS(microapps?.routes?.staking?.path)
            )}
            navigation>
            {t('staking_staking')}
          </nbx-button-text>

          <nbx-button-text
            to={microapps?.routes?.card?.path}
            navigation-active={isLinkActive(location, window.GET_LOCALE_PATHS(microapps?.routes?.card?.path))}
            navigation
            onClick={props.toggleNav}>
            {t('common_card')}
          </nbx-button-text>

          {!isCorporateAccount && (
            <nbx-button-text
              to={microapps?.routes?.referral?.path}
              navigation-active={isLinkActive(
                location,
                window.GET_LOCALE_PATHS(microapps?.routes?.referral?.path)
              )}
              navigation
              onClick={props.toggleNav}>
              {t('header_link_referral')}
            </nbx-button-text>
          )}

          <nbx-button-text
            navigation
            onClick={() => {
              props.toggleNav();
              props.openOTCModal();
            }}>
            {t('header_link_otc')}
          </nbx-button-text>

          <nbx-button-text
            to={microapps?.routes?.nft?.path}
            navigation-active={isLinkActive(location, [
              ...window.GET_LOCALE_PATHS(microapps?.routes?.nft?.path)
            ])}
            navigation
            onClick={props.toggleNav}>
            {t('header_link_nft')}
          </nbx-button-text>

          <nbx-button-text
            to={microapps?.routes?.accountGeneral?.path}
            navigation-active={isLinkActive(
              location,
              window.GET_LOCALE_PATHS(microapps?.routes?.accountGeneral?.path)
            )}
            navigation
            onClick={props.toggleNav}>
            {t('header_account')}
          </nbx-button-text>

          <nbx-button-text onClick={props.toggleNav} navigation href="https://nbxsupport.zendesk.com">
            {t('common_support')}
          </nbx-button-text>
        </div>
      </>
    );
  };

  return props.user !== null ? renderLoggedInContent() : renderLoggedOutContent();
}

MobileNavigation.propTypes = {
  user: PropTypes.object,
  toggleNav: PropTypes.func.isRequired,
  openOTCModal: PropTypes.func.isRequired,
  openQuickBuy: PropTypes.func.isRequired,
  openAddFunds: PropTypes.func.isRequired
};

MobileNavigation.defaultProps = {
  user: null
};

export default MobileNavigation;
